<template>
  <div>
    <b-button
      class="button is-primary is-medium"
      @click="isTransactionModalActive = true"
    >
      {{ $t("button.addTransaction") }}
    </b-button>

    <transaction-modal
      :isTransactionModalActive="isTransactionModalActive"
      @close="isTransactionModalActive = false"
    ></transaction-modal>
  </div>
</template>

<script>
const TransactionModal = () => import('@/components/modals/TransactionModal.vue');

export default {
  components: {
    TransactionModal
  },
  data() {
    return {
      isTransactionModalActive: false
    };
  }
};
</script>
